import * as moment from 'moment';
import { AppService } from '@app/app.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { FormControl } from '@angular/forms';
import { ManageContentService } from '../manage-content.service';
import PublicationItem from '@app/publication-item';
import tinymceConfig from '@app/tinymce-config';
declare const tinymce: any;

@Component({
  selector: 'app-edit-publication-item',
  styleUrls: ['./edit-publication-item.component.css'],
  templateUrl: './edit-publication-item.component.html',

  providers: [
    {
      provide: MAT_DATE_FORMATS,

      useValue: {
        parse: {
          dateInput: 'MMM YYYY, h:mm a',
        },

        display: {
          dateInput         : 'MMM YYYY, h:mm a',
          monthYearLabel    : 'MMMM YYYY',
          dateA11yLabel     : 'LL',
          monthYearA11yLabel: 'MMMMM YYYY',
        },
      },
    },
  ],
})
export class EditPublicationItemComponent implements OnInit {
  @Input() id: string;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  allAvailableImages: Array<{thumbnail_url: string}>;
  articleDate = new FormControl();
  data: {bodyZ: string};
  decodedBody: string;
  isImageArchiveShown = false;
  isArticleImagesListShown = false;
  isImageUploadShown = true;
  tinymceConfig = tinymceConfig;

  activeArticleImagesList() {
    this.isArticleImagesListShown = true;
    this.isImageUploadShown = false;
  }

  activeImageUpload() {
    this.isArticleImagesListShown = false;
    this.isImageUploadShown = true;
  }

  close() {
    this.onClose.emit();
  }

  insertImage(url) {
    tinymce.activeEditor.insertContent(`<img alt="Image" src="${url}" />`);
  }

  constructor(
    private appService: AppService,
    private manageContentService: ManageContentService,
  ) {}

  ngOnInit() {
    this.manageContentService
      .getPublicationItemFullData(this.id)

      .subscribe((data: {articleDate: string, bodyZ: string}) => {

        // WARN Properly setup date
        this.articleDate.setValue(moment(data.articleDate));

        this.data = data;
        this.decodedBody = atob(data.bodyZ);
      });

    this.appService
      .getAllAvailableImages()
      .subscribe((data: Array<{thumbnail_url: string}>) => { this.allAvailableImages = data; });
  }

  toggleImagesArchive() {
    this.isImageArchiveShown = !this.isImageArchiveShown;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/manage-content/edit-publication-item/edit-publication-item.component.ts